import { EVENT } from '../constants'
import trackEventFirebaseService from '../services/firebase'
import sendDeviceInfo from './sendDeviceInfo'

export function buildMultiquoteCreateEventParams({
    multiquoteType = '',
    multiquoteId = '',
    action = '',
    sourceMultiquoteId = '',
    localityId = '',
    commissionType = '',
    quoteType = '',
} = {}) {
    const params = {
        multiquoteType: multiquoteType ?? '',
        multiquoteId: multiquoteId ?? '',
        action: action ?? '',
    }

    if (sourceMultiquoteId !== '' && sourceMultiquoteId != null) {
        params.sourceMultiquoteId = sourceMultiquoteId
    }

    if (localityId !== '' && localityId != null) {
        params.localityId = localityId
    }

    if (commissionType !== '' && commissionType != null) {
        params.commissionType = commissionType
    }

    if (quoteType !== '' && quoteType != null) {
        params.quoteType = quoteType
    }

    return params
}

export function sendMultiquoteCreateEvent(params = {}) {
    trackEventFirebaseService(EVENT.KEY.MULTIQUOTE_CREATE, buildMultiquoteCreateEventParams(params))
    sendDeviceInfo(EVENT.KEY.MULTIQUOTE_CREATE)
}

export function multiquoteIdFromApiResponse(response) {
    const body = response?.data

    return body?.data?.id ?? body?.id ?? ''
}
